import { render, staticRenderFns } from "./BaseSelectMultiple.vue?vue&type=template&id=bc3fdd06&scoped=true&"
import script from "./BaseSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./BaseSelectMultiple.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectMultiple.vue?vue&type=style&index=0&id=bc3fdd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3fdd06",
  null
  
)

export default component.exports